module.exports = __webpack_public_path__ + "img/thanks.3f97e8a7.png";